export const formatKm = (km: number) => {
  if (Number.isInteger(km)) {
    return `${km} km`
  }

  const wholeNumber = Math.floor(km)
  const decimal = km - wholeNumber
  if (decimal < wholeNumber / 100) {
    return `${wholeNumber} km`
  }

  return `${km.toFixed(1)} km`
}
